// Kart Eşleştirme (USB ↔ Turnike) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'cards.pairing';

export const cardsPairingGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  mirror: true,
  title: t(`${G}.title`, 'Kart nasıl eşleştirilir?'),
  intro: t(`${G}.intro`, 'Bazı kartlarda ve bilekliklerde bilgisayara takılı USB okuyucu ile turnike okuyucusu aynı karta farklı numara verir; sistem turnike numarasını tanımadığı için geçiş izni veremez. Bu pencere iki numarayı tek kartta birleştirir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    form: t(`${G}.regions.form`, '1. Bilgisayar (USB) Okuyucu'),
    list: t(`${G}.regions.list`, '2. Turnike Okuyucu (Canlı)'),
    footer: t(`${G}.regions.footer`, 'Eşleştir'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Kartı USB okuyucuya okutun'),
      text: t(`${G}.s1.text`, 'Pencere açılınca imleç "Kartı USB okuyucuya okutun" kutusundadır. Kartı okutun (veya UID\'yi yazıp Enter\'a basın); kayıtlı kart bulunur ve altında Kart No, kart sahibi (cari veya personel), USB UID ve varsa mevcut Turnike UID görünür.'),
      tips: [
        t(`${G}.s1.tip1`, '"Kart kayıtlı değil" uyarısı çıkarsa kartı önce Kart Tanımları\'ndan ekleyin.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Aynı kartı turnikede okutun'),
      text: t(`${G}.s2.text`, 'Aynı kartı herhangi bir turnike okuyucusuna okutun. Pencere açıkken okunan en son kart otomatik seçilir (okuyucu seçmeniz gerekmez); gerekirse listeden başka bir okumayı elle seçebilirsiniz. Her satırda okunan numara, kapı adı ve saat yazar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Pencere açılmadan önceki okumalar listede görünür ama otomatik seçilmez.'),
        t(`${G}.s2.tip2`, 'Yeşil nokta ve "Canlı" yerel servise bağlı olunduğunu gösterir. "Servis yok" görünürse turnikelerin bağlı olduğu local-service\'in çalıştığından emin olun ve çıkan kutuya doğru Local Service Adresini yazın (varsayılan bu bilgisayardaki servistir).'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Eşleştir\'e basın'),
      text: t(`${G}.s3.text`, '"Eşleştir" düğmesi kart bulunup bir turnike okuması seçilince açılır ve seçili numarayı parantez içinde gösterir. Basınca turnike numarası kartın Turnike UID\'si olarak kaydedilir; eşleştirilen kart artık her iki okuyucudan da tanınır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Aynı turnike numarası başka bir kartta kayıtlıysa eşleştirme yapılmaz ve o kartın numarası uyarıda yazar.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Eşleştirmeyi kaldırma'),
      text: t(`${G}.s4.text`, 'Yanlış eşleştirdiyseniz kartı yeniden USB okuyucuya okutun ve Turnike UID\'nin yanındaki kırmızı "Eşleştirmeyi Kaldır" simgesine basın. Kart yeniden yalnız USB numarasıyla tanınır; ardından doğru turnike okumasıyla tekrar eşleştirebilirsiniz.'),
    },
  ],
});
